module.exports = __webpack_public_path__ + "d47cd857df569562104f2d153d369952.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/festival06.jpg
// module id = 797
// module chunks = 0